/**
 * Use Croppie for a simple image cropping.
 * @see  https://github.com/Foliotek/Croppie
 * @example
 *   <img-croppie src="cropped.source" ng-model="cropped.image"></img-croppie>
 */

import Croppie from 'croppie';

imgCroppie.$inject = ['_'];

/* @ngInject */
function imgCroppie(_) {
    return {
        restrict: 'E',
        scope: {
            src: '=',
            ngModel: '=',
            croppieOptions: '=',
            capture: '='
        },
        link: function ($scope, element, attrs) {
            if (!$scope.src) {
                return;
            }

            var useroptions = $scope.croppieOptions || {},
                useroptions_output = useroptions.output || {};

            var update = _.debounce(function () {
                c.result({
                    type: 'blob',
                    size: useroptions_output.size || 'viewport',
                    format: useroptions_output.format || 'png',
                    quality: 1,
                    circle: false
                }).then(function (img) {
                    $scope.$apply(function () {
                        $scope.ngModel = img;
                    });
                });
            }, 800);

            var options = angular.extend({}, imgCroppie._defaults_, useroptions, {
                update: update
            });

            var c = new Croppie(element[0], options);

            // bind an image to croppie
            $scope.$watch('src', function (src, old) {
                c.bind({
                    url: src,
                    zoom: 0
                });
            });

            $scope.$on('$destroy', c.destroy.bind(c));
        }
    };
}

imgCroppie._defaults_ = {
    viewport: {
        width: 200,
        height: 200
    },
};

export default imgCroppie;